import { CardActions } from './Actions';
import { CardContainer } from './Container';
import { CardContent } from './Content';
import { CardHeader } from './Header';
import { CardRoot } from './Root';

export const Card = {
  Actions: CardActions,
  Container: CardContainer,
  Content: CardContent,
  Header: CardHeader,
  Root: CardRoot,
};
